import * as z from 'zod';
/**
 *  This runtype should be keep in sync the the `LanguageEnum` from `@luminovo/commons`
 **/
export const LanguageEnumRuntype = z.enum(['en', 'de', 'es', 'fr', 'it']);
